export default __webpack_public_path__ + "static/media/Formula1Mobile.ac798abb.png";